import { createFileRoute } from '@tanstack/react-router';
import { RunPage } from '@/features/checklists/pages/run-page';

export const Route = createFileRoute('/_app/checklists/runs/$runId')({ component: RunPage });
